import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import ToggleEditData from 'formiojs/components/checkbox/editForm/Checkbox.edit.data';
import ToggleEditDisplay from 'formiojs/components/checkbox/editForm/Checkbox.edit.display';
import ToggleEditValidation from 'formiojs/components/checkbox/editForm/Checkbox.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: ToggleEditDisplay,
    },
    {
      key: 'data',
      components: ToggleEditData,
    },
    {
      key: 'validation',
      components: ToggleEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          type: 'select',
          data: {
            values: [
              { value: 'option1', label: 'Option 1' },
              { value: 'option2', label: 'Option 2' },
            ],
          },
          input: true,
          dataSrc: 'values',
          template: '<span>{{ item.label }}</span>',
          label: 'True value of the toggle component',
          weight: 50,
          key: 'trueValue',
          defaultValue: 'option2',
        },
        {
          weight: 150,
          type: 'textfield',
          label: 'Option 1',
          key: 'option1',
          input: true,
        },
        {
          weight: 200,
          type: 'textfield',
          label: 'Option 2',
          key: 'option2',
          input: true,
        },
        {
          weight: 250,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 300,
          type: 'textfield',
          label: 'Tooltip Title',
          key: 'tooltipTitle',
          input: true,
        }],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip: 'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Typelist in review',
          key: 'hasTypelist',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
